import GlobalHelper from "../../common/GlobalHelper"

type SavedFilterDtoAttributes = {
    content: string
    createdBy: string
    listingType: string
    name: string
    view: ViewAttributesDto
}

export type ViewAttributesDto = {
    columns: ColumnAttributesDto[]
}

export type ColumnAttributesDto = {
    attributeId: string
}

export type SavedFilterDto = {
    id: string
    type: string
    attributes: SavedFilterDtoAttributes
}

export default class SavedFilter {
    private dto: SavedFilterDto
    constructor(dto: SavedFilterDto) {
        this.dto = dto
    }

    isLoaded(): boolean {
        return this.getId() != "" && this.dto.type == "saved-filters"
    }

    getId(): string {
        return this.dto.id
    }

    getName(): string {
        return this.dto.attributes.name
    }

    getListingType(): string {
        return this.dto.attributes.listingType
    }

    getDecodedContent(): object {
        return this.dto.attributes.content ? GlobalHelper.decodeSavedFilter(this.dto.attributes.content) : {}
    }

    getView(): ViewAttributesDto {
        return this.dto.attributes.view
    }
}


// WEBPACK FOOTER //
// ./src/state/listing/SavedFilter.ts